import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideDialog, showDialog } from "../../appRedux/actions/common";
import { deleteMentor, getMentorList } from "../../appRedux/actions/mentors";
import DialogModal from "../Common/DialogModal";

const DeleteConfirmationBody = ({ info }) => {
  const dispatch = useDispatch();
  const { queryInfo } = useSelector((state) => ({
    queryInfo: state.mentors.queryInfo,
  }));

  const handleDelete = async () => {
    dispatch(hideDialog());
    await dispatch(deleteMentor(info._id));
    dispatch(getMentorList(queryInfo));
  };

  return (
    <Fragment>
      <div className="form-header text-center p-3">
        <i className="fa fa-exclamation-triangle text-warning fa-3x mb-3" />
        <h3 className="mb-2">Remove Mentor Profile</h3>
        <p className="text-muted">
          Are you sure you want to remove <strong>{info.displayName || info.name}</strong> from mentors?
          This will set their status to Inactive and remove them from active guidance callouts.
        </p>
      </div>
      <div className="modal-btn delete-action">
        <div className="row g-2 justify-content-center">
          <div className="col-5">
            <button
              type="button"
              onClick={() => dispatch(hideDialog())}
              className="btn btn-secondary w-100"
            >
              Cancel
            </button>
          </div>
          <div className="col-5">
            <button
              type="button"
              onClick={handleDelete}
              className="btn btn-danger w-100"
            >
              Confirm Remove
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

function DeleteModal({ info }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { dialog } = useSelector((state) => ({
    dialog: state.common.dialog,
  }));

  useEffect(() => {
    if (!dialog) {
      setOpen(false);
    }
  }, [dialog]);

  const handleOpen = () => {
    setOpen(true);
    dispatch(
      showDialog({
        title: "",
        hideHeader: true,
        size: "md",
        id: `delete_${info._id}`,
      })
    );
  };

  return (
    <Fragment>
      <button
        type="button"
        className="dropdown-item text-danger"
        onClick={handleOpen}
        key={`delete_mentor_${info._id}`}
      >
        <i className="fa fa-trash m-r-5" /> Remove Mentor
      </button>
      {open && (
        <DialogModal
          infoId={`delete_${info._id}`}
          bodyView={<DeleteConfirmationBody info={info} />}
        />
      )}
    </Fragment>
  );
}

export default DeleteModal;
